import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';

export default class ButtonWithTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            label: this.props.label ? this.props.label : '',
            message: this.props.message ? this.props.message : '',
            icon: this.props.icon ? this.props.icon: '',
            onclick: this.props.onclick ? this.props.onclick:() =>{},
            link: this.props.link ? this.props.link:'',
            id:this.props.id ? this.props.id:'',
            size:this.props.size ? this.props.size : '',
            open:false,
            class:this.props.class ? this.props.class:'',
            set_size:"",
            target:this.props.target ? this.props.target:'',
        };

        this.handleTooltipClose = this.handleTooltipClose.bind(this);
        this.handleTooltipOpen = this.handleTooltipOpen.bind(this);
        this.setSize = this.setSize.bind(this);
        
    }
    setIcon(){
        if(this.state.icon){
            return (<i className={this.state.icon}></i>);
        }else{
            return "";
        }
    }
    handleTooltipClose(){
        if(this.state.open == true){
            this.setState({open:false});
        }
    };
    
    handleTooltipOpen(){
        if(this.state.open == false){
            this.setState({open:true});
        }
    };

    setSize(){
        if(this.state.size == "sm"){
            this.setState({set_size:"small-btn"});
        }
    }
    UNSAFE_componentWillMount() {
        this.setSize()
    }
    componentDidUpdate(prevProps) {
        if(JSON.stringify(this.props) === JSON.stringify(prevProps))
            return;
            
        this.setState({ label: this.props.label,link: this.props.link,onclick:this.props.onclick });
    }        
    render() {
        return (
            <>
                <Tooltip onClose={this.handleTooltipClose} onOpen={this.handleTooltipOpen} open={this.state.open} title={this.state.message}>
                    <Button 
                        disabled={this.props.disabled!==undefined?this.props.disabled:false}
                        onClick={this.state.onclick}
                        target={this.state.target?this.state.target:"_parent"}
                        className={"btn btn-secondary btn-facebook " + this.state.class + " " + this.state.set_size}
                        href={this.state.link}>{this.setIcon()}&nbsp;{this.state.label}
                    </Button>
                </Tooltip>           
            </>
        );
    }
}
